import styled from 'styled-components';

export const Button = styled.button`
  background: white;
  border-radius: 5px;
  padding: 5px;
  border: solid 0.5px;
`;

export const PrimaryButton = styled.button`
  background: blue;
  border-radius: 5px;
  padding: 5px;
  border: solid 0.5px;
`;

export const customStyles = `
    overflow: hidden;
    background-color: white;
    max-height: 100%;
  `;

export const ModalBodyContainer = styled.div`
  background: white;
  height: 150px;
  padding-top: 15px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 3.75rem;
`;
export const Backdrop = styled.div`
  overflow: scroll;
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1400;
  background-color: rgba(255, 255, 255, 0.94);
`;

export const ModalMain = styled.div`
  margin: 0px auto;
  max-width: 570px;
  height: auto;
  border-radius: 0.25rem;
  box-shadow: rgb(0 0 0 / 20%) 0px 0px 16px 0px;
  z-index: 2000;
  background-color: rgb(255, 255, 255);
  top: 29%;
  idth: 100%;
  position: relative;
  left: 0;
`;

export const ModalInner = styled.div`
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  height: 100%;
`;

export const ModalMessageMain = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 3rem;
`;

export const ModalCancel = styled.div`
  float: right;
  padding: 1rem 1rem 0px 0px;
  position: absolute;
  right: 0%;
  top: 0%;
`;

export const ModalHeading = styled.div`
  overflow-wrap: break-word;
  color: rgb(42, 44, 46);
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.4;
  letter-spacing: -0.6px;
  margin-bottom: 1rem;
`;